import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=53efe916&scoped=true"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"
import style0 from "./Preferences.vue?vue&type=style&index=0&id=53efe916&prod&lang=scss&scoped=true"
import style1 from "./Preferences.vue?vue&type=style&index=1&id=53efe916&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53efe916",
  null
  
)

export default component.exports